import type { BoxProps } from '@mui/material';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MuiSvgIcon } from '../icons/MuiSvgIcon';

export const Avatar = styled(Box)<BoxProps>(() => ({
  height: 'fit-content',
  position: 'relative',
  width: 'fit-content',
}));

type PpAvatarIcon = BoxProps & { size?: number };
export const AvatarIcon = styled(Box)<PpAvatarIcon>(({ size = 4, theme }) => ({
  fontSize: theme.spacing(size),
  height: '1em',
  lineHeight: '1em',
  width: '1em',
  '& svg': {
    display: 'block',
    height: '100%',
    width: '100%',
  },
}));

export const AvatarBadge = styled(Box)<BoxProps>(() => ({
  bottom: 0,
  position: 'absolute',
  right: 0,
}));

export type PpCurrencyAvatar = PpAvatarIcon & {
  circularIcon?: boolean;
  inheritViewBox?: boolean;
  svg?: TpReactSvg | null;
};
export function AvatarIconFromSvg({
  circularIcon = false,
  inheritViewBox,
  svg,
  ...rest
}: PpCurrencyAvatar): React.ReactElement | null {
  if (!svg) {
    return null;
  }
  return (
    <AvatarIcon {...rest}>
      <MuiSvgIcon
        inheritViewBox={inheritViewBox}
        svg={svg}
        sx={{ borderRadius: circularIcon ? '50%' : '0' }}
      />
    </AvatarIcon>
  );
}
